import { cn } from "lib/utils"
import React from "react"

type TruncateProps = {
  children: React.ReactNode
  width?: number
  maxWidth?: number
  title?: string
  style?: React.CSSProperties
  className?: string
}

function Truncate({ children, width, maxWidth, title, style, className }: TruncateProps) {
  return (
    <span className={cn("truncate", className)} style={{ width, maxWidth, display: "inline-block", ...style }} title={title}>
      {children}
    </span>
  )
}

export default Truncate
